<div class="row">
    <div class="col-md-6 col-lg-6 col-xl-5 col-12 mx-auto">
        <div class="text-center">
            <div class="text-center fs-2 fw-bold mb-4">
                TEST COMPLETE
            </div>
            <div class="text-center mb-4">
                <img *ngIf="image" src="{{assetUrl+image}}" class="img-fluid rounded-4">
            </div>
        </div>
        <div class="text-center mb-4" (click)="done()">
            <button class="btn btn-done rounded-4">
                Complete
            </button>
        </div>
    </div>
</div>
